import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "../../lib/withRouter";
import Header2 from "../Header2";
import { getQuickSightUrl } from "../../lib";
import "./QuickSightReports.less";

const DASHBOARD_CONFIGS = {
    lead_source_performance: {
        apiPath: "/api/quicksight-reports/lead-source-performance/embed-url",
        iframeTitle: "Lead Source Performance Dashboard",
        defaultRoute: "/quicksight-reports?_tab=lead_source_performance"
    },
    outreach_and_enrollment: {
        apiPath: "/api/quicksight-reports/outreach-and-enrollment/embed-url",
        iframeTitle: "Outreach and Enrollment Dashboard",
        defaultRoute: "/quicksight-reports?_tab=outreach_and_enrollment"
    }
};

const DEFAULT_TAB = "lead_source_performance";

export class QuickSightReports extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        settings: PropTypes.object,
        location: PropTypes.object,
        urlParams: PropTypes.object,
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            activeTab: null,
            embedUrl: null,
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        this.syncTabAndLoad();
    }

    componentDidUpdate(prevProps) {
        const prevTab = new URLSearchParams(prevProps.location.search).get("_tab");
        const nextTab = new URLSearchParams(this.props.location.search).get("_tab");
        if (prevTab !== nextTab) {
            this.syncTabAndLoad();
        }
    }

    getTabFromLocation() {
        const tab = new URLSearchParams(this.props.location.search).get("_tab");
        return DASHBOARD_CONFIGS[tab] ? tab : null;
    }

    syncTabAndLoad = () => {
        const activeTab = this.getTabFromLocation();
        if (!activeTab) {
            this.props.router.replace(DASHBOARD_CONFIGS[DEFAULT_TAB].defaultRoute);
            return;
        }

        this.setState(
            {
                activeTab,
                embedUrl: null,
                loading: false,
                error: null
            },
            () => this.loadDashboard()
        );
    };

    loadDashboard = async () => {
        const { activeTab, embedUrl } = this.state;
        if (embedUrl) {
            this.setState({ loading: false, error: null });
            return;
        }

        const dashboardConfig = DASHBOARD_CONFIGS[activeTab];
        if (!dashboardConfig) {
            this.setState({
                loading: false,
                error: "Unknown QuickSight dashboard tab."
            });
            return;
        }

        const baseUrl = this.props.settings?.server?.baseUrl;
        if (!baseUrl) {
            this.setState({
                loading: false,
                error: "API base URL is not configured (VITE_BASE_URL)."
            });
            return;
        }

        try {
            this.setState({ loading: true, error: null });
            const apiUrl = `${baseUrl}${dashboardConfig.apiPath}`;
            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server
            });

            if (data?.embedUrl) {
                this.setState({
                    embedUrl: data.embedUrl,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false,
                    error: "QuickSight embed URL was not returned by the server."
                });
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || String(err)
            });
        }
    };

    renderTabContent() {
        const { loading, error, embedUrl, activeTab } = this.state;
        const dashboardConfig = DASHBOARD_CONFIGS[activeTab];

        if (loading) {
            return (
                <div className="patient-search-loading">
                    <i className="fa fa-spinner spin" /> Loading dashboard...
                </div>
            );
        }

        if (error) {
            return (
                <div className="quicksight-reports-error">
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => this.loadDashboard()}
                    >
                        Retry
                    </button>
                </div>
            );
        }

        if (!embedUrl || !dashboardConfig) {
            return null;
        }

        return (
            <iframe
                className="quicksight-reports-iframe"
                title={dashboardConfig.iframeTitle}
                src={embedUrl}
                width="100%"
                height="800"
            />
        );
    }

    render() {
        return (
            <div className="page quicksight-reports-page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderTabContent()}
                </div>
            </div>
        );
    }
}

export default connect((state) => state)(withRouter(QuickSightReports));
